import gql from 'graphql-tag';

import { AvatarPhoto, UserDetails } from './account';
import { PhotoUrlTypeFields } from '../../apps/consumer/graphql/fragments/global';

export const VideoDetails = gql`
  fragment VideoDetails on Video {
    id
    name
    created_at
    description
    width
    height
    duration
    embed_url
    thumbnails {
      url
      width
      height
    }
    download_enabled
    type
    account {
      id
      ...UserDetails
      ...AvatarPhoto
    }
    contributor_account {
      id
      ...UserDetails
      ...AvatarPhoto
    }
    attribution {
      name
      username
      organization_name
      avatar_photo {
        id
        thumbnail_urls {
          ...PhotoUrlTypeFields
        }
      }
      account_id
      photo_attribution_page {
        is_enabled
      }
    }
  }
  ${UserDetails}
  ${AvatarPhoto}
  ${PhotoUrlTypeFields}
`;

export const VideoPRODetails = gql`
  fragment VideoPRODetails on Video {
    ...VideoDetails

    video_links(slice: { limit: 999 }) {
      total
      records {
        ... on IVideoLink {
          id
        }

        ... on VideoAlbumFolderLink {
          album_folder {
            id
            name
          }
        }

        ... on VideoAlbumLink {
          album {
            id
            name
          }
        }

        ... on VideoAlbumPhotoGroupLink {
          album_photo_group {
            id
            name
            album {
              id
              name
            }
          }
        }
      }
    }
  }
  ${VideoDetails}
`;
